import styled from 'styled-components';

export const CustomBox = styled.div`
  position: relative;
  padding: 24px;
  background-color: ${(props) => props.theme.colors.bgBox};
  border-radius: 16px;
  counter-reset: alphabetic;
  margin-bottom: 40px;
  min-height: fit-content;

  @media ${(props) => props.theme.device.mobileL} {
    padding: 16px;
    margin-left: -16px;
    width: var(--full-width);
    border-radius: 0;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    border-radius: 16px;
    cursor: not-allowed;
  }
`;

export const InnerBox = styled.div`
  padding: 24px;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 12px;

  @media ${(props) => props.theme.device.mobileL} {
    padding: 16px;
  }

  &.is-copy {
    margin-left: 46px;
    position: relative;

    &::before {
      content: '';
      top: -24px;
      bottom: 0;
      left: -24px;
      width: 2px;
      position: absolute;
      background-size: 2px 16px;
      background-image: linear-gradient(
        to bottom,
        #22408b 0 50%,
        transparent 50% 100%
      );
      background-repeat: space;
    }

    &:not(.is-copy ~ .is-copy)::before {
      top: 0;
    }
  }
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${(props) => props.theme.colors.btnDisabledBg};
  margin: 40px auto;
`;

export const Warning = styled.div`
  display: flex;
  gap: 8px;
  color: ${(props) => props.theme.colors.textSecondary};

  svg {
    margin-top: 6px;
    stroke: ${(props) => props.theme.colors.textSecondary};
  }
`;
